<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col w-full sm:w-full md:w-full d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8 text-center">
                  <h3 class="mb-4" style="font-weight: bold;">LOGIN TO MANAGE</h3>
                </div>
                <vs-input v-validate="'required'" data-vv-as="Username" name="username" label-placeholder="Username" v-model="username" class="w-full no-icon-border" />
                <span class="text-danger text-sm">{{ errors.first('username') }}</span>
                <vs-input v-validate="'required'" data-vv-as="Password" type="password" name="password" label-placeholder="Password" v-model="password" class="w-full mt-8 no-icon-border" />
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                <div class="mt-8">
                  <vs-button class="w-full" @click="login" icon="icon icon-log-in" icon-pack="feather">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import auth from "@/services/authService"
//import { Validator } from 'vee-validate';

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      username: '',
      email: '',
      password: '',
      remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.username != '' && this.password != '';
    },
  },
  methods: {
    login() {

      this.$validator.validate().then(valid => {

        if (valid) {

          /*auth.login({
            username: this.email,
            password: this.password,
            remember: this.remember_me
          }).then(async (response) => {

            if (response.result === 'success') {

              await auth.saveLogin(response);

              this.$vs.notify({
                title: 'Success',
                text: 'Please wait...',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              });

              location.reload(true)

            } else
            if (response.result === 'error') {
              this.$vs.notify({
                title: 'Inco',
                text: response.errorText,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            } else {
              this.$vs.notify({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: 'ข้อมูลไม่ถูกต้อง',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            }
          })*/

          this.email = this.username+'@'+process.env.VUE_APP_DOMAIN
          if(process.env.VUE_APP_ADMIN_AUTH.split(',').includes(this.email)) {

            firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then((data) => {

              console.log('success', data.user.uid)

              firebase
              .auth()
              .currentUser
              .getIdToken(true)
              .then(async (idToken)=>{

                this.$vs.notify({
                  title: 'เข้าสู่ระบบสำเร็จ',
                  text: 'กรุณารอซักครู่...',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                });

                await auth.saveLogin({
                  accessToken: idToken,
                  role: 'Admin'
                });

                setTimeout(()=>{
                  location.reload(true)
                }, 1000)

              })

            })
            .catch(err => {
              this.$vs.notify({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            })

          }else{
            this.$vs.notify({
              title: 'เข้าสู่ระบบไม่สำเร็จ',
              text: 'ข้อมูลไม่ถูกต้อง',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }

        }

      })

    }

  },
  mounted() {
    /*Validator.localize('th', {
      custom: {
        email: {
          required: 'กรุณากรอกรหัสผู้ใช้'
        }
      }
    });*/
  }
}

</script>
<style lang="scss">
#page-login {
  background-color: #00308E;

  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285F4;
    }

    .bg-github {
      background-color: #333;
    }
  }

  .vs-input--placeholder {
    font-size: 1rem;
  }

  .isFocus {
    .vs-input--placeholder.normal {
      padding: 0.2rem !important;
      padding-left: 3rem !important;
    }
  }
}

</style>
